import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   getWikiEditTabsAndNav as getWikiEditTabsAndNavFromMonolith,
   WikiTabType,
   WikiEditTabsAndNavResponse,
   WikiNamespaces,
} from '~/monolith-api';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

const getWikiEditTabsAndNavSchema = z.object({
   active: z.enum(['content', 'approval_process', 'quiz']),
   namespace: z.custom<WikiNamespaces>(),
   title: z.string(),
});

export async function getWikiEditTabsAndNav(
   active: WikiTabType,
   namespace: WikiNamespaces,
   title: string,
   options: CommonRequestOptions
) {
   const response = await getWikiEditTabsAndNavFromMonolith({
      active,
      namespace,
      title,
      ...options,
   });
   return response;
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { active, namespace, title } = getWikiEditTabsAndNavSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getWikiEditTabsAndNav(active, namespace, title, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getWikiEditTabsAndNavFromClient = (
   active: WikiTabType,
   namespace: string,
   title: string
): Promise<WikiEditTabsAndNavResponse> => {
   return bff()
      .post('/wikis/getWikiEditTabsAndNav', { active, namespace, title })
      .then(response => response.data);
};

export type GetWikiEditTabsAndNavErrorCode = 'wikis.edit_tabs_and_nav_not_found';
